import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import {
  ExpertWorkspaceRecord,
  ExpertWorkspaceService,
} from '@libs/shared/api';
import { injectCoreFeature } from '@sprint-expert/app/core/state/core.service';
import { EMPTY } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

export const expertWorkspaceResolver: ResolveFn<ExpertWorkspaceRecord> = (
  route: ActivatedRouteSnapshot
) => {
  const core = injectCoreFeature();
  const router = inject(Router);
  const expertWorkspaceService = inject(ExpertWorkspaceService);
  const expertWorkspaceId = route.params['expertWorkspaceId'];

  if (!expertWorkspaceId) {
    // If no ID, we'll close the stream with EMPTY
    // This will ensure that the navigation is cancelled
    // Alternatively, you can also add a redirect
    router.navigateByUrl('/');
    return EMPTY;
  }
  // Then, we can call the getUserDetails with the ID
  // Here you can add some error handling with catchError, for example
  return expertWorkspaceService
    .fetchExpertWorkspaceById(expertWorkspaceId)
    .pipe(
      tap(expertWorkspace => {
        core.setExpertWorkspace(expertWorkspace);
      }),
      catchError(() => {
        router.navigateByUrl('/500');
        return EMPTY;
      })
    );
};
